// src/styles/commonStyles.ts
import { styled } from "@mui/material";
import { Accordion, AccordionSummary, TableCell } from "@mui/material";

// StyledTableCell
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    '&.MuiTableCell-head': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        fontSize: 16,
        fontWeight: 'bold',
    },
    '&.section-header': {
        backgroundColor: theme.palette.grey[100],
        fontWeight: 'bold',
        fontSize: 14,
        padding: '12px 16px',
    },
    '&.item-label': {
        backgroundColor: theme.palette.grey[50],
        width: 200,
        fontWeight: 'bold',
        padding: '8px 16px',
    },
}));

// StyledAccordionSummary
export const StyledAccordionSummary = styled(AccordionSummary)(() => ({
    backgroundColor: '#999999',
    color: '#ffffff',
    minHeight: '32px !important',
    padding: '0 12px',
    '& .MuiAccordionSummary-content': {
        margin: '4px 0 !important',
        '& .MuiTypography-root': {
            fontSize: '16px',
        }
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
        color: '#ffffff',
    },
}));

// StyledAccordion
export const StyledAccordion = styled(Accordion)(() => ({
    margin: 0,
    marginBottom: '0px',
    '&.MuiAccordion-root': {
        margin: 0,
        marginBottom: '0px',
    },
    '&:last-child': {
        marginBottom: 0
    }
}));